import { useQuery } from "@tanstack/react-query";

import { SimpleSelect } from "@/components/ui/select";
import { listTagsQueryOptions } from "@/lib/api";
import { CustomNodeFilter } from "@/lib/useDefaultCustomNodes";

export function CustomNodeFilterSelect({
  filter,
  setFilter,
}: {
  filter: CustomNodeFilter;
  setFilter: (filter: CustomNodeFilter) => void;
}) {
  const { data: tags } = useQuery(listTagsQueryOptions());

  return (
    <SimpleSelect
      size="sm"
      aria-label="Filter"
      options={[
        { label: "All", value: "all" },
        { label: "Created", value: "my_nodes" },
        { label: "Favorited", value: "favorited" },
        ...(tags?.map((tag) => ({
          label: tag.display_name,
          value: tag.id.toString(),
        })) || []),
      ]}
      value={filter}
      onValueChange={(v) => setFilter(v as CustomNodeFilter)}
    />
  );
}
